export default __webpack_public_path__ + "static/media/kitapp.361c117d.png";